import { type FC } from 'react';

import { Box } from '../../Box';
import { imageStyles } from './ReviewImages.styles';

export type ReviewImagesProps = {
  images: string[];
  maxImages?: number;
};

const ReviewImages: FC<ReviewImagesProps> = ({ images, maxImages = 3 }) => {
  const displayImages = images.slice(0, maxImages);

  if (displayImages.length === 0) {
    return null;
  }

  return (
    <Box display="flex" gap="var(--spacing-2)" flexWrap="wrap">
      {displayImages.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`Review ${index + 1}`}
          css={imageStyles}
        />
      ))}
    </Box>
  );
};

export default ReviewImages;
